





















import {Component, Prop, Vue} from "vue-property-decorator";

@Component({
  name:'SkeletonTable'
})
export default class SkeletonTable extends Vue {
  @Prop({type:Number,default:5}) readonly columns!: number
  @Prop({type:Number,default:5}) readonly rows!: number

  get rowsIn():number[]{
    if(!this.rows) return []
    return Array.from({ length: this.rows }, (v, i) =>  i + 1)
  }



}


